import {
  CALENDAR_DAY_END_HOUR,
  CALENDAR_DAY_START_HOUR,
  CALENDAR_SLOT_MINUTES,
  snapToSlot,
} from '@proffer/shared'
import {
  formatDateInputValue,
  pad2,
  parseDateInputValue,
} from '../components/UI/dateFormat'

export function formatLocalDateValue(date: Date): string {
  return formatDateInputValue(date)
}

export function parseLocalDateValue(value: string): Date | null {
  return parseDateInputValue(value)
}

export function formatLocalTimeValue(date: Date): string {
  const snapped = snapToSlot(date)
  return `${pad2(snapped.getHours())}:${pad2(snapped.getMinutes())}`
}

export function combineLocalDateTime(dateValue: string, timeValue: string): Date | null {
  const base = parseLocalDateValue(dateValue)
  if (!base || !timeValue) return null

  const match = /^(\d{2}):(\d{2})$/.exec(timeValue)
  if (!match) return null

  base.setHours(Number(match[1]), Number(match[2]), 0, 0)
  return snapToSlot(base)
}

export function buildAppointmentTimeOptions(): Array<{ value: string; label: string }> {
  const options: Array<{ value: string; label: string }> = []
  for (let hour = CALENDAR_DAY_START_HOUR; hour < CALENDAR_DAY_END_HOUR; hour++) {
    for (let minute = 0; minute < 60; minute += CALENDAR_SLOT_MINUTES) {
      const value = `${pad2(hour)}:${pad2(minute)}`
      options.push({ value, label: value })
    }
  }
  return options
}

export const APPOINTMENT_TIME_OPTIONS = buildAppointmentTimeOptions()

export function defaultNewAppointmentStart(): Date {
  const d = new Date()
  d.setMinutes(Math.ceil(d.getMinutes() / CALENDAR_SLOT_MINUTES) * CALENDAR_SLOT_MINUTES, 0, 0)
  if (d.getHours() >= CALENDAR_DAY_END_HOUR) {
    d.setDate(d.getDate() + 1)
    d.setHours(CALENDAR_DAY_START_HOUR, 0, 0, 0)
  }
  return snapToSlot(d)
}

export function defaultAppointmentEnd(start: Date): Date {
  return new Date(start.getTime() + 60 * 60 * 1000)
}

export function parseAppointmentStartParam(iso: string): Date | null {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return snapToSlot(d)
}
